<div class="breadcrumb">
  @if (breadCrumb) { @for (item of breadCrumb; track $index; let last = $last) { @if (templates?.[item.id]) {
  <ng-container *ngTemplateOutlet="templates[item.id]; context: { $implicit: item }"></ng-container>
  } @else {
  <a
    [routerLink]="item.routerLink"
    class="label"
    >{{ item.label }}
  </a>
  } @if (!last) {
  <mat-icon class="separator">chevron_right</mat-icon>
  } } }
</div>
